import React, { FC, useEffect, useState } from 'react';
import DataInfo from '@components/data_info';
import FormField from '@components/form_field';
import { useForm } from '@hooks/helpers/useForm';
import Input from '@components/common/input';
import { useLocales } from '@hooks/helpers/useLocales';
import DatePicker from '@components/date_picker';
import Phone from '@components/phone';
import Address from '@components/address';
import styles from './styles.module.scss';
import { EConsumerStatus } from '@xeppt/xeppt-sdk/types/consumer';
import { EAddressType, EUserStatus, TConsumer } from '@xeppt/xeppt-sdk/types';
import { userStatuses } from '@const/index';
import { useApiMutation } from '@hooks/api/useApiMutation';
import { apiAdminService } from '@api';
import { toast } from 'react-toastify';
import { Country } from 'country-state-city';

interface IProps {
    consumer?: TConsumer;
}

const PersonalSection: FC<IProps> = ({ consumer }) => {
    const { requestErrorLocale } = useLocales();
    const [isEditAddress, setIsEditAddress] = useState({
        billing: false,
        business: false,
        registration: false,
        trading: false
    });
    const form = useForm({});
    const { labelLocale } = useLocales();

    useEffect(() => {
        if (consumer) {
            form.reset({
                first_name: consumer?.profile?.first_name,
                last_name: consumer?.profile?.last_name,
                email: consumer?.email,
                birth_date: consumer?.profile?.birth_date,
                id: consumer?.id,
                created_at: consumer?.created_at,
                isVerified:
                    consumer?.status !== EConsumerStatus.UNVERIFIED &&
                    consumer?.status !== EConsumerStatus.UNCONFIRMED,
                status: consumer?.status,
                billing_address: {
                    //@ts-ignore
                    ...consumer?.billing_address,
                    country:
                        Country.getAllCountries().find(
                            //@ts-ignore
                            (item) => item.isoCode === consumer?.billing_address?.country
                            //@ts-ignore
                        )?.name || consumer?.billing_address?.country
                },
                trading_address: {
                    //@ts-ignore
                    ...consumer?.trading_address,
                    country:
                        Country.getAllCountries().find(
                            //@ts-ignore
                            (item) => item.isoCode === consumer?.trading_address?.country
                            //@ts-ignore
                        )?.name || consumer?.trading_address?.country
                },
                registration_address: {
                    //@ts-ignore
                    ...consumer?.registration_address,
                    country:
                        Country.getAllCountries().find(
                            //@ts-ignore
                            (item) => item.isoCode === consumer?.registration_address?.country
                            //@ts-ignore
                        )?.name || consumer?.registration_address?.country
                },
                business_address: {
                    //@ts-ignore
                    ...consumer?.business_address,
                    country:
                        Country.getAllCountries().find(
                            //@ts-ignore
                            (item) => item.isoCode === consumer?.business_address?.country
                            //@ts-ignore
                        )?.name || consumer?.business_address?.country
                },
                phone_code: consumer?.phone_code,
                phone_number: consumer?.phone_number
            });
        }
    }, [consumer]);

    const { handleRequest: handleUpdateAddress } = useApiMutation({
        method: (type: EAddressType) => {
            const values = form.getValues();
            const getAddress = () => {
                switch (type) {
                    case EAddressType.REGISTRATION:
                        return values.registration_address;
                    case EAddressType.BILLING:
                        return values.billing_address;
                    case EAddressType.BUSINESS:
                        return values.business_address;
                    case EAddressType.TRADING:
                        return values.trading_address;
                }
            };
            const address = getAddress();
            return apiAdminService.updateConsumerAddress(
                consumer?.id || '',
                {
                    ...address,
                    country:
                        Country.getAllCountries().find((item) => item.name === address.country)
                            ?.isoCode || address.country
                },
                type
            );
        },
        onSuccess: () => {
            toast.success('Address was updated successfully');
            setIsEditAddress({
                trading: false,
                business: false,
                registration: false,
                billing: false
            });
        },
        onError: requestErrorLocale
    });

    return (
        <div className={styles.wrapper}>
            <DataInfo label="General information" form={form}>
                <FormField
                    name="first_name"
                    renderComponent={(props) => {
                        return <Input readOnly full {...props} label={labelLocale('first_name')} />;
                    }}
                />
                <FormField
                    name="last_name"
                    renderComponent={(props) => {
                        return <Input readOnly full {...props} label={labelLocale('last_name')} />;
                    }}
                />
                <FormField
                    name="email"
                    renderComponent={(props) => {
                        return <Input readOnly full {...props} label={labelLocale('email')} />;
                    }}
                />
                <FormField<string | null>
                    name="birth_date"
                    renderComponent={(props) => {
                        return (
                            <DatePicker
                                readOnly
                                {...props}
                                label={labelLocale('birth_date')}
                                full
                            />
                        );
                    }}
                />
                {/*<FormField*/}
                {/*    name="occupancy"*/}
                {/*    renderComponent={(props) => {*/}
                {/*        return <Input full {...props} label={labelLocale('occupation')} />;*/}
                {/*    }}*/}
                {/*/>*/}
                <FormField
                    name="id"
                    renderComponent={(props) => {
                        return <Input readOnly full {...props} label={labelLocale('user_id')} />;
                    }}
                />
                <FormField<string | null>
                    name="created_at"
                    renderComponent={(props) => {
                        return (
                            <DatePicker
                                readOnly
                                {...props}
                                label={labelLocale('date_created')}
                                full
                            />
                        );
                    }}
                />
                <FormField
                    name="isVerified"
                    renderComponent={({ value, ...props }) => {
                        return (
                            <Input
                                readOnly
                                full
                                {...props}
                                label={labelLocale('verification')}
                                value={value ? 'Verified' : 'Not verified'}
                            />
                        );
                    }}
                />
                <FormField
                    name="status"
                    renderComponent={({ value, ...props }) => {
                        return (
                            <Input
                                readOnly
                                full
                                {...props}
                                label={labelLocale('status')}
                                value={
                                    userStatuses.find(
                                        //@ts-ignore
                                        (item) => item.value === (value as EUserStatus)
                                    )?.label
                                }
                            />
                        );
                    }}
                />
                <Phone readOnly label={labelLocale('phone')} isForm />
                <FormField
                    name="email"
                    renderComponent={(props) => {
                        return <Input readOnly full {...props} label={labelLocale('email')} />;
                    }}
                />
            </DataInfo>
            {/*//@ts-ignore*/}
            {consumer?.billing_address && (
                <DataInfo
                    label="Billing address"
                    showEdit
                    isEdit={isEditAddress.billing}
                    form={form}
                    full
                    onChangeEdit={() => {
                        if (!isEditAddress.billing) {
                            setIsEditAddress((state) => ({
                                ...state,
                                billing: !state.billing
                            }));
                        } else {
                            handleUpdateAddress(EAddressType.BILLING);
                        }
                    }}>
                    <Address
                        isFull
                        name="billing_address"
                        disabled={!isEditAddress}
                        isShowAutocomplete={isEditAddress.billing}
                    />
                </DataInfo>
            )}
            {/*//@ts-ignore*/}
            {consumer?.business_address && (
                <DataInfo
                    label="Business address"
                    showEdit
                    isEdit={isEditAddress.business}
                    form={form}
                    full
                    onChangeEdit={() => {
                        if (!isEditAddress.business) {
                            setIsEditAddress((state) => ({
                                ...state,
                                business: !state.business
                            }));
                        } else {
                            handleUpdateAddress(EAddressType.BUSINESS);
                        }
                    }}>
                    <Address
                        isFull
                        name="business_address"
                        disabled={!isEditAddress}
                        isShowAutocomplete={isEditAddress.business}
                    />
                </DataInfo>
            )}
            {/*//@ts-ignore*/}
            {consumer?.registration_address && (
                <DataInfo
                    label="Registration adress"
                    showEdit
                    isEdit={isEditAddress.registration}
                    form={form}
                    full
                    onChangeEdit={() => {
                        if (!isEditAddress.registration) {
                            setIsEditAddress((state) => ({
                                ...state,
                                registration: !state.registration
                            }));
                        } else {
                            handleUpdateAddress(EAddressType.REGISTRATION);
                        }
                    }}>
                    <Address
                        isFull
                        name="registration_address"
                        disabled={!isEditAddress}
                        isShowAutocomplete={isEditAddress.registration}
                    />
                </DataInfo>
            )}
            {/*//@ts-ignore*/}
            {consumer?.trading_address && (
                <DataInfo
                    label="Trading address"
                    showEdit
                    isEdit={isEditAddress.trading}
                    form={form}
                    full
                    onChangeEdit={() => {
                        if (!isEditAddress.trading) {
                            setIsEditAddress((state) => ({
                                ...state,
                                trading: !state.trading
                            }));
                        } else {
                            handleUpdateAddress(EAddressType.TRADING);
                        }
                    }}>
                    <Address
                        isFull
                        name="trading_address"
                        disabled={!isEditAddress}
                        isShowAutocomplete={isEditAddress.trading}
                    />
                </DataInfo>
            )}
        </div>
    );
};

export default PersonalSection;
